import './Button.style.css';

export default function Button({ text, variant }) {
  return (
    <button className={`button ${variant ? `variant-${variant}` : ''}`}>{text}</button>
  );
}
